<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/teacherList' }">
					<i class="el-icon-user"></i> 园丁管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>更新园丁信息</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'头像'" prop="uaaPHOT">
							<el-upload class="avatar-uploader" action="" :show-file-list="false" :auto-upload="false" :on-change="uploadImg">
								<img v-if="ruleForm.uaaPHOT" mode='aspectFill' :src="ruleForm.uaaPHOT" :onerror="defaultImg" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
					<el-col :span="12"></el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item :label="'园丁ID'" prop="uaaMSID">
							<el-input v-model="ruleForm.uaaMSID" :placeholder="'请输入园丁ID'" :disabled="true"></el-input>
						</el-form-item>
					</el-col>
				  <el-col :span="8">
						  <el-form-item :label="'手机号码'" prop="uaaPHON">
					  	<el-input v-model="ruleForm.uaaPHON" :placeholder="'请输入手机号码'" :disabled="true"></el-input>
					  </el-form-item>
					  </el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						 <el-form-item :label="'姓名'" prop="uaaNAME">
						  <el-input v-model="ruleForm.uaaNAME" :placeholder="'请输入姓名'" maxlength="20"></el-input>
						 </el-form-item>
					</el-col>
					<el-col :span="14">
						<el-form-item :label="'性别'" prop="uaaGSEX">
						<el-radio-group v-model="ruleForm.uaaGSEX">
							<el-radio label="1">男</el-radio>
							<el-radio label="0">女</el-radio>
						</el-radio-group>
						</el-form-item>
					</el-col>  
				</el-row>
				<el-row>
					  <el-col :span="8">
					  	<el-form-item :label="'生日'" prop="uaaBIRT" class="font">
					  	 <el-date-picker v-model="ruleForm.uaaBIRT" type="date" :placeholder="'请选择日期'" value-format="yyyy-MM-dd" align="center"></el-date-picker> 
					  	</el-form-item>
					  </el-col>
					 <el-col :span="24">
					 	<el-form-item :label="'手机系统'" prop="uaaDEFG">
					 	<el-radio-group v-model="ruleForm.uaaDEFG">
					 		<el-radio label="1">Android</el-radio>
					 		<el-radio label="0">IOS</el-radio>
					 	</el-radio-group>
					 	</el-form-item>
					 </el-col>  
				</el-row>
				<el-row>
					<el-col :span="8">
						 <el-form-item :label="'毕业院校'" prop="uaaSCHL">
						  <el-input v-model="ruleForm.uaaSCHL" :placeholder="'请输入毕业院校'" maxlength="20"></el-input>
						 </el-form-item>
					</el-col>
					<el-col :span="14">
						<el-form-item :label="'学历'" prop="uaaEDUC">
						<el-radio-group v-model="ruleForm.uaaEDUC">
							<el-radio label="1">本科</el-radio>
							<el-radio label="0">专科</el-radio>
						</el-radio-group>
						</el-form-item>
					</el-col>  
				</el-row>
				<el-row>
				  <el-col :span="8">
				  	 <el-form-item :label="'推送ID'" prop="uaaPHID">
				  	  <el-input v-model="ruleForm.uaaPHID" :placeholder="'请输入推送ID'" :disabled="true"></el-input>
				  	 </el-form-item>
				  </el-col> 
				   
					</el-row>
				<el-row>
				  <el-col :span="22">
				  	 <el-form-item :label="'个人简介'" prop="uaaPROF">
				  	  <el-input v-model="ruleForm.uaaPROF" type="textarea":rows="2" :placeholder="'请输入个人简介'" ></el-input>
				  	 </el-form-item>
				  </el-col> 
				</el-row>					
				<el-row>
				  <el-col :span="22">
				  	 <el-form-item :label="'备注'" prop="uaaNOTE">
				  	  <el-input v-model="ruleForm.uaaNOTE" type="textarea":rows="2" :placeholder="'请输入备注'" ></el-input>
				  	 </el-form-item>
				  </el-col>  
				</el-row>						
				</el-row>
				<el-row>
					<el-col :span="23">
						<el-form-item :label="'后台管理权限'" prop="uaaROLE">
							<el-select v-model="ruleForm.uaaROLE" clearable 
							:placeholder="'请选择后台管理权限'" 
							class="handle-select mr10">
								<el-option
									 v-for="item in ruleForm.optionsROLE"
									 :key="item.BAFMSID"
									 :label="item.BAFNAME"
									 :value="item.BAFMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="23">
						<el-form-item :label="'删除状态'" prop="uaaDELF">
								<el-select v-model="ruleForm.uaaDELF" clearable 
								:placeholder="'请选择删除状态'" 
								class="handle-select mr10">
									<el-option
										 v-for="item in ruleForm.optionsDELF"
										 :key="item.INIKEY2"
										 :label="item.INIDISP"
										 :value="item.INIKEY2">
									</el-option>
								</el-select>
							</el-form-item>
					</el-col>
			    </el-row>
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<!-- vueCropper 剪裁图片实现-->
			   <el-dialog :title="'剪裁图片'" :visible.sync="imgCutVisible" append-to-body>
			     <div class="cropper-content">
			       <div class="cropper" style="text-align:center">
					<vueCropper
						ref="cropper"
						:img="imgCutOption.img"
						:outputSize="imgCutOption.size"
						:outputType="imgCutOption.outputType"
						:info="true"
						:full="imgCutOption.full"
						:canMove="imgCutOption.canMove"
						:canMoveBox="imgCutOption.canMoveBox"
						:original="imgCutOption.original"
						:autoCrop="imgCutOption.autoCrop"
						:fixed="imgCutOption.fixed"
						:fixedNumber="imgCutOption.fixedNumber"
						:centerBox="imgCutOption.centerBox"
						:infoTrue="imgCutOption.infoTrue"
						:fixedBox="imgCutOption.fixedBox"
					  ></vueCropper>
			       </div>
			     </div>
			     <div slot="footer" class="dialog-footer">
			       <el-button @click="imgCutVisible = false">返回</el-button>
			       <el-button type="primary" @click="finish">提交</el-button>
			     </div>
			   </el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'editParent',
		inject: ['reload'],
		data() {
			//验证字符串
			const validateFontSize = (rule,value,callback)=>{	
					if (value.toString().length < 1 || value.toString().length > 20) {
						callback(new Error('请输入长度在1~20之间的字符'))  //长度在1-20之间
					} else {
						callback();
					}
			 }
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				uaaChangeData: {},
				imgCutVisible: false,
				imgCutOption: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.9, // 裁剪生成图片的质量
					outputType: 'jpg', // 裁剪生成图片的格式
					canScale: true, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例
					full: false, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				defaultImg:'this.src="' + require("../../assets/img/users_128.png") +'";this.onerror=null',
				ruleForm: {
					uaaMSID: '',
					uaaPHON: '',
					uaaDEFG: '0',
					uaaPHID: '',
					uaaSCHL: '',
					uaaEDUC: '',
					uaaNAME: '',
					uaaNICK: '',
					uaaPHOT: '',
					imgbase64: '',
					uaaGSEX: '1',
					uaaBIRT: '',
					uaaPROF: '',
					uaaNOTE: '',
					uaaROLE: '',
					uaaDELF: '',
					optionsDELF:[],
					optionsROLE:[]
				},
				rules: {
					uaaNAME:[
						{ 
						 validator: validateFontSize
						}
					  ]
					
					}
			};
		},
		watch: {
			$route(to, from) {
				if (to.name === "editTeacher") {
					this.dummyCreated();
				}
			}
		},
		created() {
			this.uaaMSID = this.$route.query.UAAMSID;
			this.Get_BAF_List2(); //获取角色
			this.getDELF(); //获取删除状态
			this.getData(this.uaaMSID);
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})		
		},
		methods: {
			dummyCreated () {
				this.uaaMSID = this.$route.query.UAAMSID;
				this.Get_BAF_List2(); //获取角色
				this.getDELF(); //获取删除状态
				this.getData(this.uaaMSID);
			},
			//上传头像
			uploadImg(file, fileList) {
				var that = this
				//判断图片类型
				if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/png' || file.raw.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				// 判断图片大小
				const isLt2M = file.raw.size / 1024 / 1024 < 20
				if (!isJPG) {
					that.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!') //上传产品图片只能是 JPG/PNG/JPEG 格式!
					return false;
				}
				if (!isLt2M) {
					that.$message.error('上传产品图片大小不能超过 20MB!') //上传产品图片大小不能超过 20MB!
					return false;
				}
			
				if (isJPG && isLt2M) {
					var reader = new FileReader();
					reader.readAsDataURL(file.raw);
					reader.onload = function(e) {
						that.imgCutOption.img = this.result;
						that.imgCutVisible = true;
					}
				}
			},
			// 剪切图片确定方法
			finish() {
			  this.$refs.cropper.getCropBlob((data) => {
				var reader = new FileReader();
				reader.readAsDataURL(data);
				var that = this;
				reader.onload = function(e) {
					that.ruleForm.uaaPHOT = this.result;
					that.ruleForm.imgbase64 = this.result;
					that.imgCutVisible = false;
				}
			  })
			},
			//获取后台管理权限信息
			Get_BAF_List2(){
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcBAF.svc/Get_BAF_List2';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sUAAID: self_shop.web_sphon, //web侧 登录邮箱
						}
					)
					.then((response) =>{
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if(resCount>0){
							this.ruleForm.optionsROLE= response.data.KKDT;
						}		
					})
					.catch((error) =>{
						this.$message({
						message: '请求失败',  //请求失败
						type: 'error'
						});
						
					});
			},
			//获取删除信息
			getDELF(){
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sINIKEY1: 10005 //删除 10005
						}
					)
					.then((response) =>{
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if(resCount>0){
							this.ruleForm.optionsDELF= response.data.KKDT;
						}		
					})
					.catch((error) =>{
						this.$message({
						message: '获取删除状态请求失败',  //请求失败
						type: 'error'
						});
						
					});
			},
			//获取园丁信息
			getData(uaaMSID) {
				const self = this;
				var postUrl = 'WCF/WEB/svcUAA.svc/GET_UAA_BYID';
				//debugger;
				//console.log(uaaMSID);
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon, 
							sMSID: uaaMSID 
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status;
						if (resStatus == "200") { //网络请求成功
							let resCount = response.data.KKDTCOUNT;
							if (resCount > 0) {
								//返回列信息赋值到页面上 
								this.ruleForm.uaaMSID = response.data.KKDT[0].UAAMSID; 
								this.ruleForm.uaaPHON = response.data.KKDT[0].UAAPHON;
								this.ruleForm.uaaDEFG = response.data.KKDT[0].UAADEFG; 
								this.ruleForm.uaaPHID = response.data.KKDT[0].UAAPHID; 
								this.ruleForm.uaaSCHL = response.data.KKDT[0].UAASCHL; 
								this.ruleForm.uaaEDUC = response.data.KKDT[0].UAAEDUC; 
								this.ruleForm.uaaPHOT = response.data.KKDT[0].UAAPHOT +"?timestamp=" + new Date().getTime(); //头像
								this.ruleForm.uaaNAME = response.data.KKDT[0].UAANAME; 
								this.ruleForm.uaaGSEX = response.data.KKDT[0].UAAGSEX;
								
								if(response.data.KKDT[0].UAAROLE==='0')
								{
									this.ruleForm.uaaROLE ='';
								}
								else{
									this.ruleForm.uaaROLE = response.data.KKDT[0].UAAROLE; 
								}
								
								this.ruleForm.uaaDELF = response.data.KKDT[0].UAADELF; 
								this.ruleForm.uaaPROF = response.data.KKDT[0].UAAPROF; 
								this.ruleForm.uaaNOTE = response.data.KKDT[0].UAANOTE; 
								this.ruleForm.uaaBIRT = response.data.KKDT[0].UAABIRT; 
								
								this.uaaChangeData = response.data.KKDT[0];
							
							} 
							else {
								this.$message({
									message: '获取数据失败', //无数据
									type: 'error'
								});
							}
						} 
						else {
							this.$message({
								message: '请求获取数据失败', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求获取数据失败', //请求失败
							type: 'error'
						});
					});
			},
			//保存园丁信息
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
	
						const self = this;
						
						var valROLE;
						if(self.ruleForm.uaaROLE == "undefined")
						{
							valROLE = '';
						}
						else
						{
							valROLE = self.ruleForm.uaaROLE;
						}
						
						var valDELF;
						if(self.ruleForm.uaaDELF == "undefined")
						{
							valDELF = '';
						}
						else
						{
							valDELF = self.ruleForm.uaaDELF;
						}
						
						let uaaFlag=false;
						if(this.uaaChangeData.UAAPHID != this.ruleForm.uaaPHID)
						{
							uaaFlag = true;
						}
						if(this.uaaChangeData.UAASCHL != this.ruleForm.uaaSCHL)
						{
							uaaFlag = true;
						}
						if(this.uaaChangeData.UAAEDUC != this.ruleForm.uaaEDUC)
						{
							uaaFlag = true;
						}
						if(this.uaaChangeData.UAAPROF != this.ruleForm.uaaPROF)
						{
							uaaFlag = true;
						}
						if(this.uaaChangeData.UAANOTE != this.ruleForm.uaaNOTE)
						{
							uaaFlag = true;
						}
						if(this.uaaChangeData.UAANAME != this.ruleForm.uaaNAME)
						{
							uaaFlag = true;
						}
						
						if(this.uaaChangeData.UAAPHOT != this.ruleForm.imgbase64)
						{
							uaaFlag = true;
						}
						
						if(this.uaaChangeData.UAABIRT != this.ruleForm.uaaBIRT)
						{
							uaaFlag = true;
						}
						if(this.uaaChangeData.UAADEFG != this.ruleForm.uaaDEFG)
						{
							uaaFlag = true;
						}
						if(this.uaaChangeData.UAAGSEX != this.ruleForm.uaaGSEX)
						{
							uaaFlag = true;
						}
						if(this.uaaChangeData.UAAROLE != valROLE)
						{
							uaaFlag = true;
						}
						
						if(this.uaaChangeData.UAADELF != valDELF)
						{
							uaaFlag = true;
						}
						
		
						var postUrl = 'WCF/WEB/svcUAA.svc/UPD_UAA_BYID';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon,  //web侧 登录ID  tihs.web_suuid
									sMSID: self.uaaMSID, //宝宝ID
									sUAADEFG: this.ruleForm.uaaDEFG,
									sUAAPHID: self.ruleForm.uaaPHID, 
									sUAASCHL: self.ruleForm.uaaSCHL,
									sUAAEDUC: self.ruleForm.uaaEDUC,
									sUAAPHOT: self.ruleForm.imgbase64,
									sUAANAME: self.ruleForm.uaaNAME,
									sUAAGSEX: this.ruleForm.uaaGSEX, 
									sUAAROLE: valROLE,
									sUAADELF: valDELF,
									sUAAPROF: self.ruleForm.uaaPROF,
									sUAANOTE: self.ruleForm.uaaNOTE,
									sUAABIRT: self.ruleForm.uaaBIRT
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '园丁信息更新失败', //编辑失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('园丁信息更新成功'); // 编辑成功
										this.$router.push('/teacherList') // 跳转路由到用户列表页
										this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件

										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "editParent") {
												indexs = i;
												break;
											}
										}
										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '请求更新园丁信息失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求更新园丁信息失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '信息更新失败', //表单验证失败
							type: 'error'
						});
						return false;
					}
				});
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editParent") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>

<style scoped>
	.avatar-uploader >>> .el-upload--text {
		background-color: #fff;
		border: 1px solid #d9d9d9;
		border-radius: 128px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 128px;
		height: 128px;
		text-align: center;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}
	.el-dialog__footer {
		text-align: center;
		height: 80px;
	}

	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}
	.select-shop .el-input {
		width: 300px;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 16px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}

	.avatar-uploader .el-upload {
		width: 128px;
		height: 128px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}

	.cropper {
	    width: auto;
	    height: 300px;
	}
</style>
